import React from 'react';
import { useTranslation } from 'react-i18next';
import { paintings } from '../../data/paintings';
import useScrollReveal from '../../hooks/useScrollReveal';

const RecentWorks = ({ onViewGallery, onViewPainting }) => {
  const [ref, isVisible] = useScrollReveal();
  const recentWorks = paintings.slice(0, 6);
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith('en');

  return (
    <section ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className={`text-center mb-16 reveal ${isVisible ? 'visible' : ''}`}>
          <span className="text-sm text-[#B8963E] tracking-widest uppercase mb-4 block">
            {t('recentWorks.label')}
          </span>
          <h2 className="text-4xl md:text-5xl mb-6 text-[#3D3831]">
            {t('recentWorks.title')}
          </h2>
          <div className="divider-elegant" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {recentWorks.map((painting, index) => (
            <div
              key={painting.id}
              className={`group cursor-pointer reveal reveal-delay-${(index % 3) + 1} ${
                isVisible ? 'visible' : ''
              }`}
              onClick={() => onViewPainting(painting)}
            >
              <div className="card-elegant overflow-hidden">
                <div className="img-zoom-container relative aspect-[4/5]">
                  <img
                    src={painting.url}
                    alt={isEnglish ? painting.titleEn || painting.title : painting.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
                <div className="p-5">
                  <h3 className="text-lg mb-1 text-[#3D3831] group-hover:text-[#B8963E] transition-colors">
                    {isEnglish ? painting.titleEn || painting.title : painting.title}
                  </h3>
                  <p className="text-sm text-[#8B7E6A]">
                    {painting.year} · {painting.technique}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className={`text-center mt-12 reveal reveal-delay-4 ${isVisible ? 'visible' : ''}`}>
          <button onClick={onViewGallery} className="btn-primary">
            {t('recentWorks.viewAll')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default RecentWorks;
